import PropTypes from "prop-types";
import styles from "./AppLayout.module.scss";
import MainContent from "./MainContent";
import MobileHeader from "./MobileHeader";
import useAppModernisation from "../../hooks/useAppModernisation";

const AppLayout = ({
  children,
  appSidebar,
  pageSidebar,
  showMainSidebar = true,
  showSidebar = true,
  sidebarHidden = false, // New prop to control sidebar visibility
  className = "",
  useMainContentWrapper = true,
  stickyPageSidebar,
  appHeader, 
  stickyPageHeader,
  showMobileHeader = true, // New prop to control MobileHeader visibility
}) => {
  const { isCalculatorsLegacyIntegration } = useAppModernisation();

  // Add conditional styling
  const containerClasses = [
    styles.appContainer,
    // FOR DROP 2: Only hide main content when NOT in calculator legacy integration mode
    // In Drop 2 (calculator integration), both sidebar and content should be visible
    showSidebar && pageSidebar && !sidebarHidden && !isCalculatorsLegacyIntegration ? styles.hideMainContent : "",
    // Add Drop 2 specific class when calculator integration is enabled
    isCalculatorsLegacyIntegration ? styles.calculatorIntegrationLayout : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const leftColumnClasses = [
    styles.leftColumn,
    sidebarHidden ? styles.hidden : "",
    stickyPageSidebar ? styles.stickyLeftColumn : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={containerClasses}>
      {/* App Header - Fixed at top on mobile/tablet ONLY */}
      <div className={styles.appHeaderContainer}>
        {showMobileHeader && <MobileHeader></MobileHeader>}
        {stickyPageHeader && <div>{stickyPageHeader}</div>}
      </div>

      {/* Content wrapper for sidebar and main content */}
      <div className={styles.contentWrapper}>
        {/* Main Application Sidebar */}
        {showMainSidebar && appSidebar && (
          <div className={styles.appSidebar}>{appSidebar}</div>
        )}

        {/* Section Sidebar */}
        {showSidebar && pageSidebar && (
          <div className={leftColumnClasses}>{pageSidebar}</div>
        )}

        {/* Section Sidebar */}
        {showSidebar && stickyPageSidebar && (
          <div className={leftColumnClasses}>{stickyPageSidebar}</div>
        )}

        {/* Content Area */}
        <div className={styles.rightColumn}>
          {/* App Header (desktop only - mobile/tablet use fixed version above) */}
          {appHeader && (
            <div className={styles.appHeaderDesktop}>
              {appHeader}
            </div>
          )}

          {/* Main Content */}
          {useMainContentWrapper ? (
            <MainContent>{children}</MainContent>
          ) : (
            children
          )}
        </div>
      </div>
    </div>
  );
};

AppLayout.propTypes = {
  children: PropTypes.node.isRequired,
  appSidebar: PropTypes.node,
  pageSidebar: PropTypes.node,
  showMainSidebar: PropTypes.bool,
  showSidebar: PropTypes.bool,
  sidebarHidden: PropTypes.bool,
  appHeader: PropTypes.node,
  className: PropTypes.string,
  useMainContentWrapper: PropTypes.bool,
  showMobileHeader: PropTypes.bool,
};

export default AppLayout;
